module.exports = __webpack_public_path__ + "media/images/icons/create-musician-disabled-a7e6d4a154c1d7275379581602d9a8c0.svg";